import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Image from 'components/Image';
import { qualityUpdate as qualityUpdatePropTypes } from 'types/quality-updates/quality-update';
import ProgressBar from './ProgressBar';

export function QualityUpdate(props) {
  const {
    data: {
      category,
      usesProgressBars,
      leftScore,
      rightScore,
      startPercentage,
      endPercentage,
      image,
      qualityName,
      message,
      tooltip,
      nature,
    },
  } = props;

  const progressBar = usesProgressBars && (
    <ProgressBar
      before={leftScore}
      category={category}
      after={rightScore}
      start={startPercentage}
      end={endPercentage}
    />
  );

  const tooltipData = {
    image,
    description: tooltip,
  };

  const classes = classnames({
    icon: true,
    'icon--circular': nature === 'Status',
  });

  return (
    <div className="quality-update">
      <div className="quality-update__left">
        <div className={classes}>
          <Image
            className="media__object"
            icon={image}
            alt={qualityName}
            width={40}
            height={40}
            type="small-icon"
            tooltipData={tooltipData}
            defaultCursor
          />
        </div>
      </div>
      <div className="quality-update__body">
        <div dangerouslySetInnerHTML={{ __html: message }} />
        {progressBar}
      </div>
    </div>
  );
}

QualityUpdate.propTypes = PropTypes.shape({
  data: { ...qualityUpdatePropTypes },
}).isRequired;

export default QualityUpdate;
